import React from 'react';
import { AnalysisResult } from '../services/projectService';
import JsonAccordion from './JsonAccordion';

interface ResultAccordionProps {
  result: AnalysisResult;
}

const ResultAccordion: React.FC<ResultAccordionProps> = ({ result }) => {
  // If there's no AI result data at all, render nothing.
  if (!result.result) {
    return <div className="no-result-placeholder">N/A</div>;
  }

  // Create an enriched data object for the accordion.
  const accordionData: any = { ...result.result };
  const isAiAssessed = !!result.ai_risk_justification;

  if (result.probability_score !== null) {
    const key = isAiAssessed ? 'ai_probability' : 'user_probability';
    accordionData[key] = result.probability_score;
  }
  if (result.impact_score !== null) {
    const key = isAiAssessed ? 'ai_impact' : 'user_impact';
    accordionData[key] = result.impact_score;
  }
  if (result.ai_risk_justification) {
    accordionData.ai_risk_justification = result.ai_risk_justification;
  }

  return <JsonAccordion data={accordionData} />;
};

export default ResultAccordion; 